import { render, staticRenderFns } from "./homework-link-from-home.vue?vue&type=template&id=371bd75e&"
import script from "./homework-link-from-home.vue?vue&type=script&lang=js&"
export * from "./homework-link-from-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports